import { render, staticRenderFns } from "./DocumentConfigurationHistory.vue?vue&type=template&id=5f43fd36&"
import script from "./DocumentConfigurationHistory.vue?vue&type=script&lang=js&"
export * from "./DocumentConfigurationHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports